import { Button, Collapse, Form, Input, Modal } from 'antd';
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import ConditionDetail from "../../Classes/ConditionDetail";
import Rule from "../../Classes/Rule";
import { pickAFileSliceDispatch, ruleModalSliceDispatch, ruleViewerSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import ConditionDetailEditor from ".././ConditionDetailEditor/ConditionDetailEditor";

function RuleModal() {
    const currentRules = useSelector((state: any) => state.pickAFile.rules);

    const open = useSelector((state: any) => state.ruleModal.open);
    const conditionDisabled = useSelector((state: any) => state.ruleModal.conditionDisabled);
    const isAddingCondition = useSelector((state: any) => state.ruleModal.isAddingCondition);
    const selectedCondition = useSelector((state: any) => state.ruleModal.selectedCondition);

    const ruleToAdd = useSelector((state: any) => state.ruleModal.ruleToAdd);
    const ruleToAddConditionsAll = useSelector((state: any) => state.ruleModal.ruleToAddConditionsAll);
    const ruleToAddConditionsAny = useSelector((state: any) => state.ruleModal.ruleToAddConditionsAny);
    const ruleToAddName = useSelector((state: any) => state.ruleModal.ruleToAddName);
    const ruleToAddEventType = useSelector((state: any) => state.ruleModal.ruleToAddEventType);

    const addModal = useSelector((state: any) => state.ruleViewer.addModal);
    const editModal = useSelector((state: any) => state.ruleViewer.editModal);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    const [form] = Form.useForm();

    let adder = AddARule;
    let editor = EditARule;

    const onSubmit = () => {
        dispatch({ type: ruleModalSliceDispatch.setConditionDisabled, payload: true })
        dispatch({ type: ruleModalSliceDispatch.setOpen, payload: false })

        let newRule = ruleToAdd;

        if (ruleToAddConditionsAll?.length > 0) {
            newRule.conditions.all = ruleToAddConditionsAll
        }
        else {
            delete newRule.conditions.all
        }

        if (ruleToAddConditionsAny?.length > 0) {
            newRule.conditions.any = ruleToAddConditionsAny
        }
        else {
            delete newRule.conditions.any
        }

        newRule.event.type = ruleToAddEventType;
        newRule.name = ruleToAddName;

        dispatch({ type: ruleModalSliceDispatch.setRuleToAdd, payload: newRule })

        //We are adding a new one
        if (addModal) {
            adder(null, newRule)
        }

        //We are editing one
        if (editModal) {
            editor(newRule?.event.type, newRule)
        }

        dispatch({ type: ruleModalSliceDispatch.setSelectedCondition, payload: null })
    }

    const onCancel = () => {
        dispatch({ type: ruleModalSliceDispatch.setOpen, payload: false })
        dispatch({ type: ruleModalSliceDispatch.setRuleToAdd, payload: new Rule() })
        dispatch({ type: ruleModalSliceDispatch.setSelectedCondition, payload: null })
    }

    const onRuleChange = (event) => {
        let valueToUse = event.target.value;

        dispatch({ type: ruleModalSliceDispatch.setRuleToAddEventType, payload: valueToUse })

        let newRule = ruleToAdd;
        newRule.conditions.all = ruleToAddConditionsAll;
        newRule.conditions.any = ruleToAddConditionsAny;
        newRule.event.type = ruleToAddEventType;
        newRule.name = ruleToAddName;

        dispatch({ type: ruleModalSliceDispatch.setRuleToAdd, payload: newRule })
    }

    const onRuleNameChange = (event) => {
        let valueToUse = event.target.value;

        dispatch({ type: ruleModalSliceDispatch.setRuleToAddName, payload: valueToUse })

        let newRule = ruleToAdd;
        newRule.conditions.all = ruleToAddConditionsAll;
        newRule.conditions.any = ruleToAddConditionsAny;
        newRule.event.type = ruleToAddEventType;
        newRule.name = ruleToAddName;

        dispatch({ type: ruleModalSliceDispatch.setRuleToAdd, payload: newRule })
    }


    const editCondition = (event) => {

        let conditionDetail = new ConditionDetail();

        let idToUse = event.target.parentElement.id

        if (!idToUse)
            idToUse = event.target.id

        let conditionToShow = ruleToAddConditionsAll?.filter(condition => condition.id === parseInt(idToUse))

        if (conditionToShow?.length > 0) {
            conditionDetail = conditionToShow[0]
            conditionDetail.andOr = "AND"
        }

        if (!(conditionToShow?.length > 0)) {
            conditionToShow = ruleToAddConditionsAny?.filter(condition => condition.id === parseInt(idToUse))

            if (conditionToShow) {
                conditionDetail = conditionToShow[0]
                conditionDetail.andOr = "OR"
            }
        }

        dispatch({ type: ruleModalSliceDispatch.setSelectedCondition, payload: conditionDetail })

        dispatch({ type: ruleModalSliceDispatch.setConditionDisabled, payload: false })
        event.preventDefault()
    }

    const deleteCondition = (event) => {
        let idToUse = event.currentTarget.id

        let filteredAllConditions = ruleToAddConditionsAll?.filter(condition => !(condition.id == parseInt(idToUse)))
        let filteredAnyConditions = ruleToAddConditionsAny?.filter(condition => !(condition.id == parseInt(idToUse)))

        dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAll, payload: filteredAllConditions ?? [] })
        dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAny, payload: filteredAnyConditions ?? [] })

        event.preventDefault()
    }

    const onSaveConditionClick = (conditionToSave) => {
        //nab the values
        let newDetail = new ConditionDetail();
        newDetail.andOr = conditionToSave.andOr;
        newDetail.id = parseInt(conditionToSave.id);
        newDetail.fact = conditionToSave.fact;
        newDetail.operator = conditionToSave.operator;
        newDetail.value = conditionToSave.value;
        //HOw to decide between AND and OR
        if (newDetail.andOr === "AND") {
            if (!ruleToAddConditionsAll) {
                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAll, payload: [] })
            }

            //Check to see if editing existing or blindly adding new
            let filteredAll = ruleToAddConditionsAll?.filter(p => p.id === newDetail.id)

            let addNew = filteredAll.length === 0

            if (addNew) {
                let newRule = ruleToAdd;
                newRule.conditions.all = ruleToAddConditionsAll;
                newRule.conditions.all.push(newDetail);

                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAll, payload: newRule.conditions.all })
            }
            else {
                let newRule = ruleToAdd;
                newRule.conditions.all = ruleToAddConditionsAll.filter(p => p.id !== newDetail.id);
                newRule.conditions.all.push(newDetail);

                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAll, payload: newRule.conditions.all })
            }
        }
        if (newDetail.andOr === "OR") {
            if (!ruleToAddConditionsAny) {
                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAny, payload: [] })
            }

            //Check to see if editing existing or blindly adding new
            let filteredAny = ruleToAddConditionsAny?.filter(p => p.id === newDetail.id)

            let addNew = filteredAny.length === 0

            if (addNew) {
                let newRule = ruleToAdd;
                newRule.conditions.any = ruleToAddConditionsAny;
                newRule.conditions.any.push(newDetail);

                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAny, payload: newRule.conditions.any })
            }
            else {
                let newRule = ruleToAdd;
                newRule.conditions.any = ruleToAddConditionsAny.filter(p => p.id !== newDetail.id);
                newRule.conditions.any.push(newDetail);

                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAny, payload: newRule.conditions.any })
            }
        }

        dispatch({ type: ruleModalSliceDispatch.setSelectedCondition, payload: null })
        dispatch({ type: ruleModalSliceDispatch.setConditionDisabled, payload: true })
    }


    const onCancelConditionClick = (event) => {
        dispatch({ type: ruleModalSliceDispatch.setSelectedCondition, payload: null })
        dispatch({ type: ruleModalSliceDispatch.setConditionDisabled, payload: true })
        dispatch({ type: ruleModalSliceDispatch.setIsAddingCondition, payload: false })
        event.preventDefault()
    }


    const onAddNewAndConditionClick = (event) => {
        form.setFields([
            {
                name: 'Conditions',
                errors: []
            }
        ]);

        handleAddConditionClick(event, "AND")
    }

    const onAddNewOrConditionClick = (event) => {
        form.setFields([
            {
                name: 'Conditions',
                errors: []
            }
        ]);

        handleAddConditionClick(event, "OR")
    }

    const onAddNewConditionClick = (event) => {
        handleAddConditionClick(event, null)
    }

    const handleAddConditionClick = (event, defaultBoolean) => {
        let newCondition = new ConditionDetail();
        //Figure out what new id should be

        const allIds = ruleToAddConditionsAll?.map(c => c.id)
        const anyIds = ruleToAddConditionsAny?.map(c => c.id)

        let maxAll = allIds?.length > 0 ? Math.max(...allIds) : 0
        let maxAny = anyIds?.length > 0 ? Math.max(...anyIds) : 0

        let maxAllCondition = maxAll + 1
        let maxAnyCondition = maxAny + 1

        newCondition.id = maxAllCondition > maxAnyCondition ? maxAllCondition : maxAnyCondition

        if (maxAllCondition > maxAnyCondition) {
            newCondition.andOr = "AND"
        }
        else {
            newCondition.andOr = "OR"
        }

        if (defaultBoolean) {
            newCondition.andOr = defaultBoolean;
        }

        dispatch({ type: ruleModalSliceDispatch.setIsAddingCondition, payload: true })

        dispatch({ type: ruleModalSliceDispatch.setSelectedCondition, payload: newCondition })
        dispatch({ type: ruleModalSliceDispatch.setConditionDisabled, payload: false })
        event.preventDefault()
    }


    let allAllConditions = ruleToAddConditionsAll ?
        ruleToAddConditionsAll?.map((condition, index) => {
            return <div key={"allAllConditions"}><span className="item"  >{index > 0 ? " AND " : ""} {condition.fact} - {condition.operator} - '{condition.value}'</span><Form.Item id={condition.id}  ><Button id={condition.id} onClick={editCondition} >Edit</Button><Button id={condition.id} onClick={deleteCondition} >Delete</Button></Form.Item></div>
        }) : null;


    let allAnyConditions = ruleToAddConditionsAny ?
        ruleToAddConditionsAny?.map((condition, index) => {
            return <div key={"allAnyConditions"}><span className="item"  >{index > 0 ? " OR " : ""} {condition.fact} - {condition.operator} - '{condition.value}'</span><Form.Item id={condition.id}><Button id={condition.id} onClick={editCondition} >Edit</Button><Button id={condition.id} onClick={deleteCondition} >Delete</Button></Form.Item></div>
        }) : null;

    let allConditions =
        <Collapse
            style={{ width: '100%' }}
        >
            {allAllConditions}
            {allAnyConditions}
        </Collapse>

    function AddARule(oldList, newRule) {
        let listToUse;
        if (oldList) {
            listToUse = oldList;
        } else {
            listToUse = currentRules
        }

        listToUse.push(newRule)

        dispatch({ type: pickAFileSliceDispatch.setRules, payload: listToUse })
        dispatch({ type: ruleViewerSliceDispatch.setRuleSearchResults, payload: listToUse })

        CreateContentsFromStates({ rules: listToUse });
    }

    function DeleteARule(ruleIdToDelete, updateState: boolean = true) {
        let filteredRules = currentRules.filter(rule => rule.event.type != ruleIdToDelete);

        if (updateState) {
            dispatch({ type: pickAFileSliceDispatch.setRules, payload: filteredRules })
            CreateContentsFromStates({ rules: filteredRules });
        }

        return filteredRules;
    }

    function EditARule(oldRuleId, newRule) {
        let filteredRules = DeleteARule(oldRuleId, false)
        AddARule(filteredRules, newRule)
    }

    return (
        <Modal
            title="Rule Details"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
            onCancel={onCancel}
        >
            <Form
                form={form}
                onFinish={onSubmit}
                preserve={false}
            >
                <Form.Item name="Rule ID" label="Rule ID">
                    <Input id="ruleId" placeholder='Rule ID' defaultValue={ruleToAddEventType} onChange={onRuleChange} />
                </Form.Item>
                <Form.Item name="Rule Name" label="Rule Name">
                    <Input id="name" placeholder='Rule Name' defaultValue={ruleToAddName} onChange={onRuleNameChange} />
                </Form.Item>
                <Form.Item rules={[{
                    validator(rule, value) {
                        return new Promise((resolve, reject) => {
                            if ((!ruleToAddConditionsAll && !ruleToAddConditionsAny) || ruleToAddConditionsAll?.length <= 0 && ruleToAddConditionsAny?.length <= 0) {
                                reject('Please add a condition to the rule.');
                            }
                            else {
                                resolve(undefined);
                            }
                        })
                    }
                }]} name="Conditions" label="Conditions">
                    {
                        ((!allAllConditions && !allAnyConditions) || (allAllConditions?.length === 0 && allAnyConditions?.length === 0)) &&
                        <div key={ruleToAddName}>
                            <Button onClick={onAddNewAndConditionClick}>Add New AND Condition</Button>
                            <Button onClick={onAddNewOrConditionClick}>Add New OR Condition</Button>
                        </div>
                    }
                    {(allAllConditions?.length > 0 || allAnyConditions?.length > 0) &&
                        <Button onClick={onAddNewConditionClick} >Add new Condition</Button>}
                    {allConditions}
                </Form.Item>
                {!conditionDisabled && <ConditionDetailEditor
                    conditionToShow={selectedCondition}
                    isAddingCondition={isAddingCondition}
                    onSaveConditionClick={onSaveConditionClick}
                    conditionDisabled={conditionDisabled}
                    onCancelConditionClick={onCancelConditionClick}
                />}
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}

export default RuleModal
